const PackBundle = {

  state: {
    selected:         [],
    extras:           [],
    currentStep:      1,
    unlockModalShown: false,
    loadMore: {
      isLoading:     false,
      nextPage:      2,
      totalPages:    1,
      perPage:       24,
      totalProducts: 0,
    },
    config: {
      minItems:     4,
      maxItems:     6,
      discountCode: 'PACK15',
      discountPct:  15,
    },
  },

  refs: {},

  init() {
    const cfg = window.PackConfig || {};
    Object.assign(this.state.config, {
      minItems:     Number(cfg.minItems)    || 4,
      maxItems:     Number(cfg.maxItems)    || 6,
      discountCode: cfg.discountCode        || 'PACK15',
      discountPct:  Number(cfg.discountPct) || 15,
    });

    this._cacheRefs();
    this._initLoadMore();
    this._initFilterDrag();
    this._bindEvents();
    this.updateStickyBar();
  },

  _cacheRefs() {
    const $ = (id) => document.getElementById(id);
    this.refs = {
      grid:             $('pack-product-grid'),
      filterScroll:     $('pack-filter-scroll'),
      stickyBar:        $('pack-sticky-bar'),
      stickyPrice:      $('pack-sticky-price'),
      stickyOriginal:   $('pack-sticky-original-price'),
      stickyCta:        $('pack-sticky-cta'),
      stickyCtaLabel:   $('pack-sticky-cta-label'),
      stickyHintText:   $('pack-sticky-hint-text'),
      stickyThumbs:     $('pack-sticky-thumbs'),
      progressBar:      $('pack-progress-bar'),
      progressFill:     $('pack-progress-fill'),
      unlockModal:      $('pack-unlock-modal'),
      step1:            document.querySelector('[data-pack-step="1"]'),
      step2:            document.querySelector('[data-pack-step="2"]'),
      step3:            document.querySelector('[data-pack-step="3"]'),
      upsellThumbs:     $('pack-upsell-thumbs'),
      upsellOriginal:   $('pack-upsell-original-price'),
      upsellDiscounted: $('pack-upsell-discounted-price'),
      upsellRemaining:  $('pack-upsell-remaining'),
      compThumbs:       $('pack-comp-thumbs'),
      compOriginal:     $('pack-comp-original-price'),
      compDiscounted:   $('pack-comp-discounted-price'),
      finalDiscounted:  $('pack-final-discounted-price'),
      checkoutBtn:      $('pack-checkout-btn'),
      loadingOverlay:   $('pack-loading-overlay'),
      loadMoreWrap:     $('pack-load-more-wrap'),
      loadMoreBtn:      $('pack-load-more-btn'),
      shownCount:       $('pack-shown-count'),
    };
  },

  _initLoadMore() {
    const btn = this.refs.loadMoreBtn;
    if (!btn) return;
    const lm         = this.state.loadMore;
    lm.totalPages    = parseInt(btn.dataset.totalPages,    10) || 1;
    lm.perPage       = parseInt(btn.dataset.perPage,       10) || 24;
    lm.totalProducts = parseInt(btn.dataset.totalProducts, 10) || 0;
    lm.nextPage      = 2;
  },

  _initFilterDrag() {
    const el = this.refs.filterScroll;
    if (!el) return;

    let isDown     = false;
    let startX     = 0;
    let scrollLeft = 0;
    let hasDragged = false;

    const onDown = (e) => {
      isDown     = true;
      hasDragged = false;
      startX     = (e.touches ? e.touches[0].pageX : e.pageX) - el.offsetLeft;
      scrollLeft = el.scrollLeft;
      el.classList.add('is-dragging');
    };

    const onUp = () => {
      isDown = false;
      el.classList.remove('is-dragging');
    };

    const onMove = (e) => {
      if (!isDown) return;
      const x    = (e.touches ? e.touches[0].pageX : e.pageX) - el.offsetLeft;
      const walk = (x - startX) * 1.4;
      if (Math.abs(walk) > 4) hasDragged = true;
      el.scrollLeft = scrollLeft - walk;
      if (!e.touches) e.preventDefault();
    };

    el.addEventListener('click',     (e) => { if (hasDragged) e.stopPropagation(); }, true);
    el.addEventListener('mousedown',  onDown);
    el.addEventListener('touchstart', onDown,  { passive: true });
    document.addEventListener('mouseup',  onUp);
    document.addEventListener('touchend', onUp);
    el.addEventListener('mousemove',  onMove);
    el.addEventListener('touchmove',  onMove, { passive: false });
    el.addEventListener('mouseleave', onUp);

    const updateFades = () => {
      const wrap = el.closest('.pack-selector__filters');
      if (!wrap) return;
      wrap.classList.toggle('has-scroll-left',  el.scrollLeft > 4);
      wrap.classList.toggle('has-scroll-right', el.scrollLeft < el.scrollWidth - el.clientWidth - 4);
    };

    el.addEventListener('scroll', updateFades, { passive: true });
    requestAnimationFrame(updateFades);
  },

  _bindEvents() {
    document.addEventListener('click', (e) => {
      const toggleBtn = e.target.closest('[data-pack-toggle]');
      if (toggleBtn) { this.toggleProduct(toggleBtn.dataset.packToggle); return; }

      const qtyBtn = e.target.closest('[data-pack-qty]');
      if (qtyBtn) { this.updateQuantity(qtyBtn.dataset.packQty, parseInt(qtyBtn.dataset.packDelta, 10)); return; }

      const goStep = e.target.closest('[data-pack-go-step]');
      if (goStep) { this.goToStep(parseInt(goStep.dataset.packGoStep, 10)); return; }

      if (e.target.closest('[data-pack-sticky-cta]')) { this._onStickyCta(); return; }
      if (e.target.closest('[data-pack-modal-close]')) { this.closeUnlockModal(); return; }

      const compAdd = e.target.closest('[data-comp-add]');
      if (compAdd) { this._toggleExtra(compAdd.dataset.compAdd, parseInt(compAdd.dataset.compPrice, 10)); return; }

      if (e.target.closest('#pack-checkout-btn')) { this._checkout(); return; }
      if (e.target.closest('[data-pack-load-more]')) { this._loadMore(); return; }
    });

    document.addEventListener('click', (e) => {
      const pill = e.target.closest('[data-pack-filter]');
      if (!pill) return;
      const filter = pill.dataset.packFilter;

      document.querySelectorAll('[data-pack-filter]').forEach((p) => {
        p.classList.toggle('pack-selector__filter-pill--active', p === pill);
        p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
      });

      this._applyFilter(filter);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeUnlockModal();
    });
  },

  toggleProduct(variantId) {
    const existing = this.state.selected.find((s) => s.variantId === variantId);

    if (existing) {
      this.state.selected = this.state.selected.filter((s) => s.variantId !== variantId);
    } else {
      if (this.getTotalQuantity() >= this.state.config.maxItems) {
        this._showToast(`Máximo ${this.state.config.maxItems} productos por pack`);
        return;
      }
      const card = document.querySelector(`[data-pack-card][data-variant-id="${CSS.escape(variantId)}"]`);
      if (!card) return;
      this.state.selected.push({
        variantId,
        productId: card.dataset.productId,
        title:     card.dataset.title,
        image:     card.dataset.image,
        price:     parseInt(card.dataset.price, 10),
        quantity:  1,
      });
    }

    this.updateProductCard(variantId);
    this.updateStickyBar();
    this._checkUnlock();
  },

  updateQuantity(variantId, delta) {
    const item = this.state.selected.find((s) => s.variantId === variantId);
    if (!item) return;

    const newQty   = item.quantity + delta;
    const newTotal = this.getTotalQuantity() + delta;

    if (newQty < 1) {
      this.state.selected = this.state.selected.filter((s) => s.variantId !== variantId);
      this.updateProductCard(variantId);
      this.updateStickyBar();
      this._checkUnlock();
      return;
    }

    if (delta > 0 && newTotal > this.state.config.maxItems) {
      this._showToast(`Máximo ${this.state.config.maxItems} productos por pack`);
      return;
    }

    item.quantity = newQty;
    this.updateProductCard(variantId);
    this.updateStickyBar();
  },

  getTotalQuantity() {
    return this.state.selected.reduce((sum, s) => sum + s.quantity, 0);
  },

  getTotalPrice() {
    return this.state.selected.reduce((sum, s) => sum + s.price * s.quantity, 0);
  },

  getExtrasPrice() {
    return this.state.extras.reduce((sum, e) => sum + e.price * e.quantity, 0);
  },

  getDiscountedTotal(base) {
    return Math.round(base * (100 - this.state.config.discountPct) / 100);
  },

  isPackUnlocked() {
    return this.getTotalQuantity() >= this.state.config.minItems;
  },

  updateProductCard(variantId) {
    const card = document.querySelector(`[data-pack-card][data-variant-id="${CSS.escape(variantId)}"]`);
    if (!card) return;

    const item       = this.state.selected.find((s) => s.variantId === variantId);
    const overlayBtn = card.querySelector('[data-pack-toggle]');
    const stepper    = card.querySelector('.pack-card__stepper');
    const qtyEl      = card.querySelector('.pack-card__stepper-qty');

    if (item) {
      card.classList.add('pack-card--selected');
      if (overlayBtn) {
        overlayBtn.setAttribute('aria-pressed', 'true');
        overlayBtn.setAttribute('aria-label', `Quitar ${card.dataset.title} del pack`);
      }
      if (stepper) { stepper.hidden = false; stepper.setAttribute('aria-hidden', 'false'); }
      if (qtyEl)   qtyEl.textContent = item.quantity;
    } else {
      card.classList.remove('pack-card--selected');
      if (overlayBtn) {
        overlayBtn.setAttribute('aria-pressed', 'false');
        overlayBtn.setAttribute('aria-label', `Agregar ${card.dataset.title} al pack`);
      }
      if (stepper) { stepper.hidden = true; stepper.setAttribute('aria-hidden', 'true'); }
    }
  },

  updateStickyBar() {
    const { refs, state } = this;
    const { minItems, maxItems } = state.config;
    const qty      = this.getTotalQuantity();
    const total    = this.getTotalPrice();
    const unlocked = this.isPackUnlocked();

    const pct = Math.min((qty / maxItems) * 100, 100);
    if (refs.progressFill) {
      requestAnimationFrame(() => { refs.progressFill.style.width = `${pct}%`; });
    }
    if (refs.progressBar) {
      refs.progressBar.setAttribute('aria-valuenow', qty);
      refs.progressBar.setAttribute('aria-valuemax', maxItems);
    }

    document.querySelectorAll('[data-milestone]').forEach((el) => {
      el.classList.toggle('pack-selector__milestone--reached', qty >= parseInt(el.dataset.milestone, 10));
    });

    this._renderStickyThumbs();

    if (refs.stickyPrice) {
      if (unlocked && total > 0) {
        refs.stickyOriginal.textContent = this._money(total);
        refs.stickyOriginal.hidden      = false;
        refs.stickyPrice.textContent    = this._money(this.getDiscountedTotal(total));
      } else if (total > 0) {
        refs.stickyOriginal.hidden   = true;
        refs.stickyPrice.textContent = this._money(total);
      } else {
        refs.stickyOriginal.hidden   = true;
        refs.stickyPrice.textContent = '';
      }
    }

    if (refs.stickyCta) {
      const remaining = minItems - qty;
      if (qty === 0) {
        refs.stickyCta.disabled = true;
        refs.stickyCta.setAttribute('aria-disabled', 'true');
        if (refs.stickyCtaLabel) refs.stickyCtaLabel.textContent = `Elige ${minItems} productos para empezar`;
        if (refs.stickyHintText) refs.stickyHintText.textContent = `Selecciona al menos ${minItems} productos`;
      } else if (!unlocked) {
        refs.stickyCta.disabled = true;
        refs.stickyCta.setAttribute('aria-disabled', 'true');
        if (refs.stickyCtaLabel) refs.stickyCtaLabel.textContent = `${remaining} más para desbloquear`;
        if (refs.stickyHintText) refs.stickyHintText.textContent = `Te faltan ${remaining} producto${remaining !== 1 ? 's' : ''}`;
      } else {
        refs.stickyCta.disabled = false;
        refs.stickyCta.setAttribute('aria-disabled', 'false');
        if (refs.stickyCtaLabel) refs.stickyCtaLabel.textContent = `Continuar (${qty} productos)`;
        if (refs.stickyHintText) refs.stickyHintText.textContent = `¡Pack desbloqueado! ${state.config.discountPct}% de descuento activo`;
      }
      refs.stickyCta.classList.toggle('pack-sticky__cta--unlocked', unlocked);
    }
  },

  _renderStickyThumbs() {
    if (!this.refs.stickyThumbs) return;
    const slots = this.refs.stickyThumbs.querySelectorAll('.pack-sticky__thumb-slot');

    const flat = [];
    this.state.selected.forEach((s) => {
      for (let q = 0; q < s.quantity; q++) flat.push(s);
    });

    slots.forEach((slot, i) => {
      slot.innerHTML = '';
      if (flat[i]) {
        const img     = document.createElement('img');
        img.src       = flat[i].image;
        img.alt       = flat[i].title;
        img.loading   = 'lazy';
        img.className = 'pack-sticky__thumb-img';
        slot.appendChild(img);
        slot.classList.add('pack-sticky__thumb-slot--filled');
      } else {
        const span         = document.createElement('span');
        span.className     = 'pack-sticky__thumb-empty';
        span.setAttribute('aria-hidden', 'true');
        span.textContent   = i + 1;
        slot.appendChild(span);
        slot.classList.remove('pack-sticky__thumb-slot--filled');
      }
    });
  },

  _checkUnlock() {
    if (this.isPackUnlocked() && !this.state.unlockModalShown) {
      this.state.unlockModalShown = true;
      this.showUnlockModal();
    }
  },

  showUnlockModal() {
    const modal = this.refs.unlockModal;
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.setAttribute('scroll-lock', '');
    modal.querySelector('button')?.focus();
  },

  closeUnlockModal() {
    const modal = this.refs.unlockModal;
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.removeAttribute('scroll-lock');
  },

  async _applyFilter(filter) {
    const grid = this.refs.grid;
    if (!grid) return;

    grid.classList.add('is-filtering');

    const handle = filter === 'all'
      ? grid.dataset.mainCollection
      : filter;

    const lm = this.state.loadMore;

    try {
      const res = await fetch(`/collections/${handle}/products.json?limit=${lm.perPage}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      grid.innerHTML = '';

      if (!data.products?.length) {
        const empty = document.createElement('p');
        empty.className = 'pack-selector__empty paragraph';
        empty.textContent = 'No hay productos en esta colección.';
        grid.appendChild(empty);
      } else {
        data.products.forEach((p) => grid.appendChild(this._buildCard(p)));
      }

      grid.dataset.activeFilter = filter;

      lm.nextPage      = 2;
      lm.isLoading     = false;
      lm.totalProducts = data.products?.length || 0;

      const hasMore = data.products?.length === lm.perPage;
      if (hasMore) {
        this.refs.loadMoreWrap?.classList.remove('pack-load-more--hidden');
        if (this.refs.shownCount) this.refs.shownCount.textContent = lm.perPage;
      } else {
        this._hideLoadMore();
      }

      this.state.selected.forEach((item) => this.updateProductCard(item.variantId));

    } catch (err) {
      console.error('[PackBundle] filter error:', err);
      this._showToast('Error al filtrar. Intenta de nuevo.');
    } finally {
      grid.classList.remove('is-filtering');
      grid.classList.add('is-filtered');
      setTimeout(() => grid?.classList.remove('is-filtered'), 400);
    }
  },

  async _loadMore() {
    const lm = this.state.loadMore;
    if (lm.isLoading) return;

    lm.isLoading = true;
    this._setLoadMoreLoading(true);

    const grid   = this.refs.grid;
    const filter = grid?.dataset.activeFilter || 'all';
    const handle = filter === 'all'
      ? grid?.dataset.mainCollection
      : filter;

    try {
      const res = await fetch(`/collections/${handle}/products.json?limit=${lm.perPage}&page=${lm.nextPage}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      if (!data.products?.length) {
        this._hideLoadMore();
        return;
      }

      data.products.forEach((p) => grid.appendChild(this._buildCard(p)));

      lm.nextPage++;
      lm.totalProducts += data.products.length;
      if (this.refs.shownCount) this.refs.shownCount.textContent = lm.totalProducts;

      if (data.products.length < lm.perPage) this._hideLoadMore();

    } catch (err) {
      console.error('[PackBundle] loadMore error:', err);
      this._showToast('Error al cargar más productos. Intenta de nuevo.');
    } finally {
      lm.isLoading = false;
      this._setLoadMoreLoading(false);
    }
  },

  _buildCard(product) {
    const variant        = product.variants.find((v) => v.available) || product.variants[0];
    const available      = variant.available;
    const priceInCents   = Math.round(parseFloat(variant.price) * 100);
    const rawImg         = typeof product.featured_image === 'string'
      ? product.featured_image
      : product.featured_image?.src || product.images?.[0]?.src || null;
    const imgBase        = rawImg?.split('?')[0] || null;
    const imgSrc         = imgBase ? `${imgBase}?width=400` : null;
    const thumbSrc       = imgBase ? `${imgBase}?width=120` : null;
    const titleEsc       = this._escAttr(product.title);
    const variantIdStr   = String(variant.id);

    const card = document.createElement('div');
    card.className = `pack-card${available ? '' : ' pack-card--soldout'}`;
    card.setAttribute('role', 'listitem');
    card.dataset.packCard  = '';
    card.dataset.variantId = variantIdStr;
    card.dataset.productId = String(product.id);
    card.dataset.price     = priceInCents;
    card.dataset.available = available;
    card.dataset.title     = product.title;
    card.dataset.image     = thumbSrc || '';

    card.innerHTML = `
      ${available ? `<button class="pack-card__overlay-btn" type="button" data-pack-toggle="${variantIdStr}" aria-label="Agregar ${titleEsc} al pack" aria-pressed="false"></button>` : ''}
      <div class="pack-card__image-wrap">
        ${imgSrc
          ? `<img src="${imgSrc}" alt="${titleEsc}" loading="lazy" decoding="async" class="pack-card__image">`
          : `<div class="pack-card__image-placeholder"></div>`
        }
        ${!available ? `<span class="pack-card__soldout-label" aria-hidden="true">Agotado</span>` : ''}
        <div class="pack-card__selected-check" aria-hidden="true">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" fill="currentColor"/>
            <path d="M8 12l3 3 5-5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <div class="pack-card__info">
        <p class="pack-card__title paragraph">${titleEsc}</p>
        <p class="pack-card__price paragraph">${this._money(priceInCents)}</p>
      </div>
      <div class="pack-card__stepper-wrap">
        ${available
          ? `<div class="pack-card__stepper" hidden aria-hidden="true" role="group" aria-label="Cantidad de ${titleEsc}">
               <button class="pack-card__stepper-btn" type="button" data-pack-qty="${variantIdStr}" data-pack-delta="-1" aria-label="Reducir cantidad">−</button>
               <span class="pack-card__stepper-qty" id="pack-qty-${variantIdStr}" aria-live="polite" aria-atomic="true">1</span>
               <button class="pack-card__stepper-btn" type="button" data-pack-qty="${variantIdStr}" data-pack-delta="1" aria-label="Aumentar cantidad">+</button>
             </div>`
          : `<div class="pack-card__soldout-btn" aria-hidden="true">Agotado</div>`
        }
      </div>
    `;

    return card;
  },

  _setLoadMoreLoading(active) {
    const btn     = this.refs.loadMoreBtn;
    const spinner = btn?.querySelector('.pack-load-more__spinner');
    const label   = btn?.querySelector('.pack-load-more__label');
    if (!btn) return;
    btn.disabled = active;
    btn.setAttribute('aria-disabled', active ? 'true' : 'false');
    if (spinner) spinner.hidden = !active;
    if (label)   label.textContent = active ? 'Cargando...' : 'Cargar más productos';
  },

  _updateShownCount() {
    const el = this.refs.shownCount;
    if (!el) return;
    const lm       = this.state.loadMore;
    el.textContent = Math.min((lm.nextPage - 1) * lm.perPage, lm.totalProducts);
  },

  _hideLoadMore() {
    this.refs.loadMoreWrap?.classList.add('pack-load-more--hidden');
  },

  goToStep(step) {
    [
      { el: this.refs.step1, n: 1 },
      { el: this.refs.step2, n: 2 },
      { el: this.refs.step3, n: 3 },
    ].forEach(({ el, n }) => {
      if (!el) return;
      el.hidden = n !== step;
      el.setAttribute('aria-hidden', n !== step ? 'true' : 'false');
    });

    this.state.currentStep = step;
    if (this.refs.stickyBar) this.refs.stickyBar.hidden = step !== 1;
    if (step === 2) this._renderUpsell();
    if (step === 3) this._renderComplements();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },

  _onStickyCta() {
    if (!this.isPackUnlocked()) return;
    this.goToStep(2);
  },

  _renderUpsell() {
    const base       = this.getTotalPrice();
    const discounted = this.getDiscountedTotal(base);
    const remaining  = this.state.config.maxItems - this.getTotalQuantity();

    if (this.refs.upsellOriginal)   this.refs.upsellOriginal.textContent   = this._money(base);
    if (this.refs.upsellDiscounted) this.refs.upsellDiscounted.textContent = this._money(discounted);
    if (this.refs.upsellRemaining)  this.refs.upsellRemaining.textContent  = remaining;

    if (this.refs.upsellThumbs) {
      this.refs.upsellThumbs.innerHTML = '';
      this.state.selected.forEach((item) => {
        for (let q = 0; q < item.quantity; q++) {
          const el     = document.createElement('div');
          el.className = 'pack-upsell__thumb';
          el.setAttribute('role', 'listitem');
          el.innerHTML = `<img src="${item.image}" alt="${this._escAttr(item.title)}" loading="lazy">`;
          this.refs.upsellThumbs.appendChild(el);
        }
      });
    }
  },

  _toggleExtra(variantId, price) {
    const idx = this.state.extras.findIndex((e) => e.variantId === variantId);
    const btn = document.querySelector(`[data-comp-add="${CSS.escape(variantId)}"]`);

    if (idx > -1) {
      this.state.extras.splice(idx, 1);
      if (btn) {
        btn.textContent = 'Agregar';
        btn.classList.remove('pack-comp-card__btn--added');
        btn.closest('.pack-comp-card')?.classList.remove('pack-comp-card--added');
      }
    } else {
      this.state.extras.push({ variantId, price, quantity: 1 });
      if (btn) {
        btn.textContent = '✓ Agregado';
        btn.classList.add('pack-comp-card__btn--added');
        btn.closest('.pack-comp-card')?.classList.add('pack-comp-card--added');
      }
    }

    this._renderComplements();
  },

  _renderComplements() {
    const packBase       = this.getTotalPrice();
    const packDiscounted = this.getDiscountedTotal(packBase);
    const extrasTotal    = this.getExtrasPrice();
    const grandTotal     = packDiscounted + extrasTotal;

    if (this.refs.compThumbs) {
      this.refs.compThumbs.innerHTML = '';
      this.state.selected.forEach((item) => {
        for (let q = 0; q < item.quantity; q++) {
          const el     = document.createElement('div');
          el.className = 'pack-upsell__thumb';
          el.setAttribute('role', 'listitem');
          el.innerHTML = `<img src="${item.image}" alt="${this._escAttr(item.title)}" loading="lazy">`;
          this.refs.compThumbs.appendChild(el);
        }
      });
    }

    if (this.refs.compOriginal)   this.refs.compOriginal.textContent   = this._money(packBase);
    if (this.refs.compDiscounted) this.refs.compDiscounted.textContent = this._money(packDiscounted);
    if (this.refs.finalDiscounted) this.refs.finalDiscounted.textContent = this._money(grandTotal);
  },

  async _checkout() {
    if (!this.isPackUnlocked()) return;
    this._setLoading(true);

    const items = [
      ...this.state.selected.map((s) => ({ id: s.variantId, quantity: s.quantity })),
      ...this.state.extras.map((e)   => ({ id: e.variantId, quantity: e.quantity })),
    ];

    try {
      await fetch('/cart/clear.js', { method: 'POST' });

      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error(`Cart error: ${res.status}`);

      window.location.href = `/checkout?discount=${encodeURIComponent(this.state.config.discountCode)}`;
    } catch (err) {
      this._setLoading(false);
      this._showToast('Error al procesar el pedido. Intenta de nuevo.');
      console.error('[PackBundle] checkout error:', err);
    }
  },

  _setLoading(active) {
    const { loadingOverlay: overlay, checkoutBtn: btn } = this.refs;
    if (overlay) { overlay.hidden = !active; overlay.setAttribute('aria-hidden', active ? 'false' : 'true'); }
    if (btn)     { btn.disabled = active;    btn.setAttribute('aria-disabled', active ? 'true' : 'false'); }
  },

  _showToast(message) {
    let toast = document.getElementById('pack-toast');
    if (!toast) {
      toast = Object.assign(document.createElement('div'), { id: 'pack-toast', className: 'pack-toast' });
      toast.setAttribute('role', 'alert');
      toast.setAttribute('aria-live', 'assertive');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('pack-toast--visible');
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(() => toast.classList.remove('pack-toast--visible'), 3500);
  },

  _money(cents) {
    return (cents / 100).toLocaleString('es', {
      style:                 'currency',
      currency:              'EUR',
      minimumFractionDigits: 0,
    });
  },

  _escAttr(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  },
};

document.addEventListener('DOMContentLoaded', () => PackBundle.init());